var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMediaYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 19,
  viewBox: "0 0 27 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.806 2.943a3.34 3.34 0 0 0-2.33-2.38C21.421 0 13.18 0 13.18 0S4.936 0 2.88.563a3.34 3.34 0 0 0-2.33 2.38C0 5.043 0 9.424 0 9.424s0 4.38.55 6.481a3.34 3.34 0 0 0 2.331 2.38c2.055.563 10.298.563 10.298.563s8.242 0 10.297-.563a3.34 3.34 0 0 0 2.33-2.38c.551-2.1.551-6.481.551-6.481s0-4.381-.55-6.48"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  d: "m10.241 13.571 7.449-4.07-7.449-4.072z"
})));
export default SvgSocialMediaYoutube;